import React, { Component, PropTypes } from 'react';
import { FormGroup, Table } from 'react-bootstrap';

const moment = require('moment');

class ExistingCoverNote extends Component {
  constructor(props) {
    super(props);
    this.periodOfInsuranceFormat = this.periodOfInsuranceFormat.bind(this);
  }

  periodOfInsuranceFormat(existingCoverNote) {
    return `${moment(existingCoverNote.coverageInfo.coveragePeriodFrom).format('DD/MM/YYYY')} to ${moment(existingCoverNote.coverageInfo.coveragePeriodTo).format('DD/MM/YYYY')}`
  }

  render() {
    return (
      <div className="ebaoUtil__Top-Bottom-Line-0">
          <FormGroup controlId="">
          {this.props.existingCoverNotes.length > 0 ? <div className="text-danger">Existing Cover Note of This Vehicle Found</div> : null}
          <Table responsive>
            <thead>
              <tr>
                <th>Cover Note Number</th>
                <th>Insured Name</th>
                <th>Vehicle Number</th>
                <th>Business Type</th>
                <th>Period of Insurance</th>
              </tr>
            </thead>
            <tbody>
              {this.props.existingCoverNotes.map((existingCoverNote, index) => {
                const counter = index
                return (
                  <tr key={counter}>
                    <td>{existingCoverNote.coverNoteEntry.coverNoteNo}</td>
                    <td>{existingCoverNote.coverNoteEntry.insuredName}</td>
                    <td>{existingCoverNote.particularOfVehicle.vehicleRegNo}</td>
                    <td>{existingCoverNote.coverNoteEntry.businessType}</td>
                    <td>{this.periodOfInsuranceFormat(existingCoverNote)}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </FormGroup>
      </div>
    )
  }
}

ExistingCoverNote.propTypes = {
  existingCoverNotes: PropTypes.array,
};

export default ExistingCoverNote;



// WEBPACK FOOTER //
// ./src/app/components/coverNotePVComponent/existingCoverNote/ExistingCoverNote.js